var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "dropdown" }, [
      _c("button", {
        staticClass: "btn btn-secondary dropdown-toggle add-btn",
        attrs: {
          type: "button",
          "data-toggle": "dropdown",
          "aria-haspopup": "true",
          "aria-expanded": "false",
          disabled: !_vm.isUserAdmin || !_vm.data.selected.company,
        },
      }),
      _c("div", { staticClass: "dropdown-menu nav-bar-menu" }, [
        _c(
          "a",
          {
            staticClass: "dropdown-item add",
            attrs: {
              "data-toggle": "modal",
              "data-target": "#group-modal",
              href: "#",
            },
            on: {
              click: function ($event) {
                return _vm.initGroup()
              },
            },
          },
          [_c("font-awesome-icon", { attrs: { icon: "plus" } })],
          1
        ),
        _c(
          "a",
          {
            staticClass: "dropdown-item edit",
            attrs: {
              "data-toggle": "modal",
              "data-target": "#group-modal",
              href: "#",
            },
            on: {
              click: function ($event) {
                return _vm.editGroup()
              },
            },
          },
          [_c("font-awesome-icon", { attrs: { icon: "edit" } })],
          1
        ),
      ]),
    ]),
    _c(
      "div",
      {
        staticClass: "modal fade",
        attrs: { id: "group-modal", tabindex: "-1", role: "dialog" },
      },
      [
        _c(
          "div",
          {
            staticClass: "modal-dialog modal-dialog-centered",
            attrs: { role: "document" },
          },
          [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                _vm.group.id === 0
                  ? _c(
                      "h5",
                      {
                        staticClass: "modal-title",
                        attrs: { id: "group-modal-label" },
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("addNewGroup")) + " ")]
                    )
                  : _vm._e(),
                _vm.group.id > 0
                  ? _c(
                      "h5",
                      {
                        staticClass: "modal-title",
                        attrs: { id: "group-modal-label" },
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("addNewGroup")) + " ")]
                    )
                  : _vm._e(),
                _vm._m(0),
              ]),
              _c("div", { staticClass: "modal-body pt-3" }, [
                _c("div", { staticClass: "input-group input-group-sm mb-3" }, [
                  _c("div", { staticClass: "input-group-prepend" }, [
                    _c("span", { staticClass: "input-group-text" }, [
                      _vm._v(_vm._s(_vm.$t("groupName"))),
                    ]),
                  ]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.group.name,
                        expression: "group.name",
                        modifiers: { trim: true },
                      },
                    ],
                    class: [
                      { "is-invalid": _vm.getValidateObject("name") },
                      "form-control",
                    ],
                    attrs: { type: "text", placeholder: _vm.$t("groupName") },
                    domProps: { value: _vm.group.name },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.group, "name", $event.target.value.trim())
                      },
                      blur: function ($event) {
                        return _vm.$forceUpdate()
                      },
                    },
                  }),
                ]),
                _c(
                  "div",
                  {
                    class: {
                      "invalid-feedback": _vm.getValidateObject("name"),
                    },
                  },
                  _vm._l(_vm.getValidateObject("name"), function (error) {
                    return _c("span", [_vm._v(_vm._s(error))])
                  }),
                  0
                ),
                _c(
                  "div",
                  {
                    staticClass: "alert alert-dismissible fade",
                    class: {
                      show: _vm.showResultBox,
                      "alert-success": !_vm.resultError,
                      "alert-danger": _vm.resultError,
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.result) + " ")]
                ),
              ]),
              _c("div", { staticClass: "modal-footer" }, [
                _c(
                  "span",
                  {
                    staticClass: "wait",
                    class: { "fade-in": _vm.waitingForSave === true },
                  },
                  [_vm._v(_vm._s(_vm.$t("pleaseWait")))]
                ),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary btn-sm",
                    attrs: {
                      type: "button",
                      disabled: _vm.waitingForSave,
                      "data-dismiss": "modal",
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("cancel")) + " ")]
                ),
                _vm.group.id === 0
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-primary btn-sm",
                        attrs: {
                          type: "button",
                          disabled: !_vm.isUserAdmin || _vm.waitingForSave,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.saveGroup()
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("addGroup")) + " ")]
                    )
                  : _vm._e(),
                _vm.group.id > 0
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-primary btn-sm",
                        attrs: {
                          type: "button",
                          disabled: !_vm.isUserAdmin || _vm.waitingForSave,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.saveGroup()
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("saveChanges")) + " ")]
                    )
                  : _vm._e(),
              ]),
            ]),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "close",
        attrs: { type: "button", "data-dismiss": "modal" },
      },
      [_c("span", [_vm._v("×")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }